import { SubscriptionBar } from "@/components/alert";
import { BorderLinearProgress } from "@/components/progress";
import { getProgressPercentage } from "@/libraries/helper";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface AccountInfoStatusProps {
	isFreePlan: boolean;
	isPlusPlan: boolean;
	isProPlan: boolean;
	maxCase: number;
	caseLeft: number;
	planStartOn?: string;
}

const AccountInfoStatus = (props: AccountInfoStatusProps) => {
	const { t } = useTranslation("settings");
	const caseCount = useMemo(() => {
		const caseLimit = props.maxCase;
		const currentCase = props.caseLeft;
		return Math.round(caseLimit - currentCase);
	}, [props]);

	if (props.isProPlan) return null;

	return (
		<>
			<Divider />
			<Box className="px-4">
				<p className="text-xs font-medium">
					{t("casesQuota")}
					<span className="float-end">
						{caseCount}/{props.maxCase}
					</span>
				</p>
				<BorderLinearProgress
					variant="determinate"
					value={getProgressPercentage(caseCount, props.maxCase)}
				/>
			</Box>
			{!props.caseLeft ? (
				<SubscriptionBar
					caseLeft={props.caseLeft}
					startOn={props.planStartOn}
					className="rounded-b-xl"
				/>
			) : null}
		</>
	);
};

export default AccountInfoStatus;
